// Internal lirbary imports
import CustomTooltip from '../CustomToolTip/CustomTooltip';

const IconComponent = ({ icon: Icon, size = '1.2vw', style = {}, tooltip }) => {
    const defaultStyle = {
        width: size,
        height: size,
        color: 'var(--color-primary)',
        cursor: 'pointer',
    };

    const iconElement = <Icon style={{ ...defaultStyle, ...style }} />;

    return tooltip ? <CustomTooltip content={tooltip}>{iconElement}</CustomTooltip> : <span>{iconElement}</span>;
};

export default IconComponent;
